import { withMods } from '@epam/uui-core';
import { VirtualList as uuiVirtualList, VirtualListProps } from '@epam/uui-components';
import * as css from './VirtualList.scss';

export interface VirtualListMods {}

function applyVirtualListMods(mods: VirtualListMods) {
    return [
        css.root,
    ];
}

export const VirtualList = withMods<VirtualListProps, VirtualListMods>(uuiVirtualList, applyVirtualListMods);
